export enum ElementPosition {
  BottomLeft = 'bottomLeft',
  BottomRight = 'bottomRight',
  TopLeft = 'topLeft',
  TopRight = 'topRight',
}

export enum WebinarType {
  Simple = 0,
  Playlist = 1,
  RtmpEncoder = 2,
}
